import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../utils/api';
import { toast } from 'react-toastify';

export const getAllexcessThunk = createAsyncThunk(
    'excess/getAllSchedule',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllexcessEnq(config);
            //   console.log("nnnnn",response.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const getexcessStatisticsThunk = createAsyncThunk(
    'excess/getexcessStatisticsThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getexcessEnqStatistics(config);
              console.log("staticssssssss",response.data?.data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const excessDetailsThunk = createAsyncThunk(
    'excess/excessDetailsThunk',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.getexcessDetails(id);

            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const exportexcessThunk = createAsyncThunk(
    'order/exportexcessThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllexcessEnq(config);
            //   console.log(response.data?.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const deleteexcessThunk = createAsyncThunk(
    'order/deleteorder',
    async (id, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.deleteexcessEnq(id?.id ?? id, id?.password);
            dispatch(setexcessrefresh())
            toast.success('excess enquiry deleted successfully')
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to delete excess enquiry')
        }
    }
);

export const deleteProductFromexcessThunk = createAsyncThunk(
    'excess/deleteprofromexcess',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.deleteProductFromexcessenq(data);
            dispatch(setexcessrefresh())
            toast.success('product deleted from enquiry  successfully')
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to delete product')
        }
    }
);

export const updateProductFromexcessThunk = createAsyncThunk(
    'order/updateProductFromSchedule',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.updateProductFromexcessenq(data);
            dispatch(setexcessrefresh())
            toast.success('product updated from enquiry  successfully')
            return response.status;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to update product')
        }
    }
);

export const getAlterProductsThunk = createAsyncThunk(
    'excess/getAlterProductsThunk  ',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getExcessAlternateProducts(data);
            console.log(response.data); 
            
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const getMatchedProductsThunk = createAsyncThunk(
    'excess/getMatchedProductsThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getMatchedProducts(data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const getSuppliersThunk = createAsyncThunk(
    'excess/getSuppliersThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getSuppliers(data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'Failed to load suppliers');
            return rejectWithValue(error?.response?.data);
        }
    }
);


export const createexcessQuoteThunk = createAsyncThunk(
    'excess/createexcessQuoteThunk',  
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.createexcessQoute(data);
            console.log(response.data);
            dispatch(setexcessrefresh())
            toast.success('quote updated successfully')
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'something went wrong')
        }
    }
);


const excessenqSlice = createSlice({
    name: 'excess',
    initialState: {
        excessenquiry: [],
        excessEnquiryDetails: {},
        excessenquiryStatistics: {
            data: {},
            loading: false
        },
        suppliers:{
            data:[],
            loading:false
        },
        macthedProducts:[],
        refresh: false,
        loading: false,
        alterProducts:{},
        alterLoading:false,
        exportLoading: false,
        error: null,
        selectedTab: 0,
        page: 1,
        search: '',
        status: '',
        fromDate: '',
        toDate: '',
    },
    reducers: {

        setexcessrefresh: (state, action) => {
            state.refresh = !state.refresh;
        },
        setexcessPage: (state, action) => {
            state.page = action.payload
        },
        setexcessSearch: (state, action) => {
            state.search = action.payload
        },
        setexcessStatus: (state, action) => {
            state.status = action.payload
        },
        setexcessFromDate: (state, action) => {
            state.fromDate = action.payload
        },
        setexcessToDate: (state, action) => {
            state.toDate = action.payload
        },
        setexcessSelectedTab: (state, action) => {
            state.selectedTab = action.payload
        },
        setexcessData: (state, action) => {
            state.orderDetails = {
                ...state.orderDetails, // Keep existing fields
                products: action.payload, // Update only products
            };
        },
        deleteAlterProduct: (state, action) => {
            const partNumberToRemove = action.payload; 
        
            state.alterProducts.alternateProducts = state.alterProducts.alternateProducts?.filter(
                (i) => {
                    const productNumber = Array.isArray(i?.productOverview?.productNumber)
                        ? i.productOverview.productNumber.join("") 
                        : i?.productOverview?.productNumber; 
        
                    return productNumber !== partNumberToRemove; 
                }
            );
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllexcessThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllexcessThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.excessenquiry = action.payload;
            })
            .addCase(getAllexcessThunk.rejected, (state, action) => {
                state.loading = false;
            })


            .addCase(getAlterProductsThunk.pending, (state) => {
                state.alterLoading = true;
            })
            .addCase(getAlterProductsThunk.fulfilled, (state, action) => {
                state.alterLoading = false;
                state.alterProducts = action.payload
            })
            .addCase(getAlterProductsThunk.rejected, (state, action) => {
                state.alterLoading = false;
            })

            //details
            .addCase(excessDetailsThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(excessDetailsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.excessEnquiryDetails = action.payload;
            })
            .addCase(excessDetailsThunk.rejected, (state, action) => {
                state.loading = false;
            })

            //details
            .addCase(exportexcessThunk.pending, (state) => {
                state.exportLoading = true;
            })
            .addCase(exportexcessThunk.fulfilled, (state, action) => {
                state.exportLoading = false;
            })
            .addCase(exportexcessThunk.rejected, (state, action) => {
                state.exportLoading = false;
            })

            //statistics
            .addCase(getexcessStatisticsThunk.pending, (state) => {
                state.excessenquiryStatistics.loading = true;
            })
            .addCase(getexcessStatisticsThunk.fulfilled, (state, action) => {
                state.excessenquiryStatistics.loading = false;
                state.excessenquiryStatistics.data = action.payload
            })
            .addCase(getexcessStatisticsThunk.rejected, (state, action) => {
                state.excessenquiryStatistics.loading = false
            })

            .addCase(getMatchedProductsThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getMatchedProductsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.macthedProducts = action.payload
            })
            .addCase(getMatchedProductsThunk.rejected, (state, action) => {
                state.loading = false;
            })


            .addCase(getSuppliersThunk.pending, (state) => {
                state.suppliers.loading = true;
                state.suppliers.data = [];
            })
            .addCase(getSuppliersThunk.fulfilled, (state, action) => {
                state.suppliers.loading = false;
                state.suppliers.data = action.payload
            })
            .addCase(getSuppliersThunk.rejected, (state, action) => {
                state.suppliers.loading = false;
            })
    },
});

export const { setexcessrefresh, setexcessPage, setexcessSearch, setexcessStatus, setexcessFromDate, setexcessToDate, setexcessSelectedTab, setexcessData,deleteAlterProduct } = excessenqSlice.actions
export default excessenqSlice.reducer;

